"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPalette = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  paletteColor: function paletteColor(props) {
    return {
      fontFamily: 'IranSansX',
      width: "180px",
      height: "200px",
      borderRadius: "5px",
      backgroundColor: _variables.colors[props.color],
      border: "none",
      outline: "none",
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "float": "left",
      margin: "20px"
    };
  },
  paletteColorName: function paletteColorName(props) {
    return {
      fontFamily: "IranSansX",
      fontSize: "16px",
      color: props.color === 'ghost' || props.color === 'swan' ? _variables.colors.night : _variables.colors.ghost
    };
  },
  codeCard: {
    fontFamily: "IranSansX",
    width: "140px",
    height: "40px",
    borderRadius: "5px",
    backgroundColor: _variables.colors.ghost,
    border: "none",
    outline: "none",
    position: "absolute",
    bottom: "18px",
    left: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  codeCardText: {
    fontFamily: "IranSansX",
    fontSize: "16px",
    color: _variables.colors.night
  },
  list: {
    display: "flex",
    justifyContent: "space-between"
  }
}));

var ColorPalette = function ColorPalette(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = useStyles(props);
  var name = props.name,
      color = props.color;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.paletteColor)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.paletteColorName)
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.codeCard)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.codeCardText)
  }, _variables.colors[color])));
};

exports.ColorPalette = ColorPalette;
ColorPalette.propTypes = {
  /** Color type */
  color: _propTypes["default"].oneOf(["father", "fatherHover", "mother", "motherHover", "ghost", "swan", "hare", "whale", "wolf", "night", "sky", "oceans", "fire", "fox", "bee", "kiwi"]),

  /** Color Name */
  name: _propTypes["default"].string
};
ColorPalette.defaultProps = {
  color: "father",
  name: "Father"
};